import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-background-100"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2.5 top-2.5 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-bold text-foreground-950">
          {comic.category}
        </span>
        <span className="absolute right-2.5 top-2.5 flex h-6 min-w-6 items-center justify-center rounded-full bg-foreground-950/70 px-1.5 text-xs font-bold text-background-50">
          {comic.rating}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{comic.title}</h3>
        <div className="mt-1.5 flex flex-wrap gap-1">
          {comic.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-900">
              #{tag}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-emotion-laugh-line text-primary-500" aria-hidden="true" />
            {comic.author}
          </span>
          <span className={comic.status === '连载中' ? 'text-primary-600' : 'text-secondary-600'}>{comic.status}</span>
        </div>
      </div>
    </Link>
  );
}